module.exports = __webpack_public_path__ + "img/media_liabary_main_.1b0f29a3.jpg";